<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table noDataText="Nenhum Usuário Encontrado" class="tablePrincipal" ref="table" v-model="selected"
      :max-items="itemsPerPage" :data="itens">
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="nome">ID</vs-th>
        <vs-th sort-key="nome">Nome</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="email">Celular</vs-th>
        <vs-th sort-key="tipo">Solicitado em</vs-th>
        <vs-th v-if="$can('afiliados', 'edit')">Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.idUsuario }}</p>
            </vs-td>

            <vs-td>
              <vs-list-item :title="tr.nome" :subtitle="tr.Setor">
                <template slot="avatar">
                  <vs-avatar />
                </template>
              </vs-list-item>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.celular }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ formataData(tr.dataAfiliadoSolicitado) }}
              </p>
            </vs-td>

            <vs-td>
              <div class="vx-row">
                <div class="vx-col">
                  <vs-button v-if="$can('afiliados', 'edit')" v-tooltip="'Editar Usuário'" radius color="success"
                    type="gradient" icon-pack="feather" icon="icon-edit" class="d-inline"
                    @click="openModalAlteracao(tr)"></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-card>
      <vs-pagination :max="screenWidth < 650 ? 5 : 9" v-if="qtdPaginas" :total="qtdPaginas"
        v-model="paginaAtual"></vs-pagination></vs-card>
    <!------------ END TABELA ------------>

    <vs-popup v-if="userAlteracao != {}" class="holamundo" :title="'Atualizar Afiliado'" :active.sync="modalAlteracao"
      @close="modalAlteracao = false">
      <FormUsuarioAfiliado :dados="userAlteracao" @cancel="modalAlteracao = false" @concluido="concluido"
        :sideBar="true" :contadorRender="contadorRender"></FormUsuarioAfiliado>
    </vs-popup>
    <!------------ END INFORMAÇÕES DO USUÁRIO ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../../Includes/SideBar";
import service from "./../../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "./../../../components/ModalInfo";
import formCadastro from "./FormUsuario.vue";
import jwt from "jsonwebtoken";
import dataFunctions from "../../../utils/dateConversion";
import moment from "moment";
import FormUsuarioAfiliado from "./FormUsuarioAfiliado.vue";
export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    formCadastro,
    ModalInfo,
    FormUsuarioAfiliado,
  },
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        this.buscaDados();
        this.$emit("filtroOk", true);
      }
    },
    paginaAtual: function () {
      console.log(this.paginaAtual);
      this.buscaDados();
    },
    itemsPerPage: function () {
      console.log(this.itemsPerPage);
      this.buscaDados();
    },
  },
  props: ["filtro", "realizaFiltro", "subjectPermission"],
  data() {
    return {
      decoded: service.getDecoded(),
      idEmpresa: null,
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: "Usuario",
      formSideBar: "usuario",
      entidade: "Usuário",
      titleSideBar: "Adicionar Usuario",
      popupActive: false,
      modalAlteracao: false,
      modalSelecionado: [],
      userAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      paginaAtual: 1,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      contadorRender: 0,
      senha: null,
      screenWidth: null,
      form: {},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    formataData(data) {
      //return dataFunctions.converteISOToDate(data);
      return moment(data).utc().format("DD/MM/YYYY hh:mm");
    },
    atualizarUsuario() {
      if (this.form.idUsuario) {
        this.$vs.loading();
        console.log(this.form);
        service
          .post(this.controllerGeral, "AtualizarUsuarioAfilado", this.form)
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Atualizado Alterada(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.userAlteracao = null;
            this.modalAlteracao = false;
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      }
    },
    verificaAdmin() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == "Super User") this.isAdmin = true;
      }
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    buscaDados() {
      this.filtred = true;
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;

      service
        .post("Usuario", "ListarAfiliadosALiberar", objSend)
        .then((res) => {
          this.itens = [];
          console.log(res.data);
          this.exibir = true;
          this.itens = [];
          this.itens = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idUsuario == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
      this.contadorRender = this.contadorRender + 1;
    },
    openModalAlteracao(user) {
      this.userAlteracao = user;
      this.modalAlteracao = true;
      this.contadorRender = this.contadorRender + 1;
      //this.userAlteracao = this.itens.find((x) => x.idUsuario == cod);
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idUsuario == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.modalAlteracao = false;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }

  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }

  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }

  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }

  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }

  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
